// --- Conteúdo completo para o arquivo: assets/tabela-filtro-moeda.js ---

(function() {
  document.addEventListener('DOMContentLoaded', () => {

    // --- ENCONTRA OS ELEMENTOS PRINCIPAIS ---
    const menuContainer = document.querySelector('.menu-categorias-personalizado');
    
    // Se não encontrar o menu, não faz mais nada.
    if (!menuContainer) {
      return;
    }

    const menuToggle = menuContainer.querySelector('.menu-toggle');
    const linksDoMenu = menuContainer.querySelectorAll('.lista-categorias a.filter-button');
    const allProductRows = document.querySelectorAll('#comparative-mining-table-js .product-row-js');

    // Se não houver links ou linhas, a funcionalidade de filtro não é necessária.
    if (linksDoMenu.length === 0 || allProductRows.length === 0) {
      console.warn('Filtro de Categoria: Links de filtro ou linhas da tabela não encontrados.');
    }

    // --- 1. LÓGICA PARA CLICAR NO LINK (ATIVAR E FILTRAR) ---
    function handleMenuClick(event) {
      event.preventDefault(); // Impede que o link mude a URL
      
      const clickedLink = event.currentTarget;
      const filter = clickedLink.dataset.filter;

      // --- Parte Visual (Do seu script original) ---
      linksDoMenu.forEach(link => {
        link.classList.remove('active');
      });
      clickedLink.classList.add('active');

      // --- Parte Funcional (Lógica de filtragem ATUALIZADA) ---

      // Transforma o filtro em um array.
      // "bitcoin" vira ["bitcoin"]
      // "litecoin,dogecoin" vira ["litecoin", "dogecoin"]
      const requiredMoedas = filter.split(',');

      allProductRows.forEach(row => {
        if (filter === 'todos') {
          // Se o filtro for "todos", mostra a linha
          row.style.display = 'table-row'; 
        } else {
          // Pega a(s) moeda(s) da linha (ex: "dogecoin,litecoin")
          // Adiciona '|| ""' para garantir que nunca seja nulo.
          const rowMoeda = row.dataset.moeda || ''; 
          
          // A MÁGICA ESTÁ AQUI:
          // Usamos .every() para checar se CADA item do array 'requiredMoedas'
          // está incluído na string 'rowMoeda'.
          const hasAllMoedas = requiredMoedas.every(moeda => rowMoeda.includes(moeda.trim())); // .trim() remove espaços em branco
          
          if (hasAllMoedas) {
            // Se a linha tem TODAS as moedas necessárias, mostra.
            row.style.display = 'table-row';
          } else {
            // Se faltar UMA que seja, esconde.
            row.style.display = 'none';
          }
        }
      });
      
      // Fecha o menu no mobile após clicar em um item
      if (window.innerWidth < 860) {
        menuContainer.classList.remove('open');
      }
    } // Fim da função handleMenuClick

    // Adiciona o "escutador" de clique em cada link
    linksDoMenu.forEach(link => {
      link.addEventListener('click', handleMenuClick);
    });

    // --- 2. LÓGICA PARA ABRIR E FECHAR O MENU (Do seu script original) ---
    if (menuToggle) {
      menuToggle.addEventListener('click', function() {
        // Ação só ocorre em telas menores que 860px
        if (window.innerWidth < 860) {
          menuContainer.classList.toggle('open');
        }
      });
    }

    // --- 3. SCRIPT PARA AJUSTAR A LARGURA DO PAI (Do seu script original) ---
    const paiDoMenu = menuContainer.parentElement;
    if (paiDoMenu) {
      paiDoMenu.style.width = '100%';
    }

  }); // Fim do DOMContentLoaded
})();